import { makeStyles } from "@material-ui/core/styles";

export const useSubscriptionStyles = makeStyles(theme => ({
  section: {
    padding: 0,
    overflowY: "auto",
    maxWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      paddingBottom: "86px",
      height: "calc(100vh - 80px)",
    },
  },
  /** Monetization: scroll long content inside settings column */
  monetizationSection: {
    padding: 0,
    overflowY: "auto",
    overflowX: "hidden",
    maxWidth: "100%",
    maxHeight: "calc(100vh - 140px)",
    minHeight: 0,
    boxSizing: "border-box",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "thin",
    scrollbarColor: "#363636 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#363636",
      borderRadius: 4,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      paddingBottom: "86px",
      maxHeight: "none",
      height: "calc(100vh - 80px)",
    },
  },
  sectionTitle: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "32px",
    marginBottom: "4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      marginTop: "24px",
    },
  },
  infoText: {
    color: "#FFFFFFCC",
    fontSize: "14px",
    fontWeight: 400,
    marginBottom: "24px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "4px",
    },
  },
  tierCard: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    margin: "40px 0",
    [theme.breakpoints.down("sm")]: {
      margin: "24px 0",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    height: "auto",
    padding: "0px !important",
    backgroundColor: "transparent",
    "& .MuiPaper-root": {
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "16px",
    },
  },
  cardContentMonetization: {
    gap: "24px",
  },
  tierHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "8px",
    },
  },
  tierHeaderMonetization: {
    marginBottom: "0",
  },
  tierName: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: 700,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      flexDirection: "column",
      gap: 8,
    },
  },
  formRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
    gap: "16px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
      width: "100%",
    },
  },
  label: {
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    minWidth: "120px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto",
      fontSize: "16px",
      marginBottom: "4px",
    },
  },
  inputField: {
    border: "1px solid #747474",
    background: "#1F1F1F",
    borderRadius: "8px",
    flex: 1,
    "& .MuiInputBase-root": { color: "white" },
    "& .MuiOutlinedInput-root": {
      //  "& fieldset": { borderColor: "#EDECED" },
      "&:hover fieldset": { borderColor: "#f06ec4" },
      "&.Mui-focused fieldset": { borderColor: "#f06ec4" },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
    },
  },
  messageText: {
    borderRadius: "8px",
    backgroundColor: "#1F1F1F80",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 400,
    padding: 16,
  },
  subscriptionSelect: {
    backgroundColor: "#131313",
    borderRadius: "8px",
    border: "1px solid #1F1F1F",
    fontSize: 16,
    padding: "2px",
    "& .MuiSelect-select": {
      padding: "8px",
    },
  },
  menuPaper: {
    padding: "8px 16px",
    backgroundColor: "#131313",
    marginTop: 8,
    borderRadius: 8,
  },
  saveButton: {
    backgroundColor: "#FE5A97",
    color: "white",
    float: "right",
    fontSize: "16px",
    textTransform: "none",
    padding: "10px 32px",
    "&:hover": { backgroundColor: "#d45ca5" },
    [theme.breakpoints.down("sm")]: {
      float: "none",
      fontSize: "12px",
      padding: "8px 16px",
      width: "max-content",
    },
  },
  cancelButton: {
    border: "1px solid #FE5A97",
    color: "white",
    float: "right",
    fontSize: "16px",
    textTransform: "none",
    padding: "10px 32px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "8px 16px",
    },
  },
  addMoreButton: {
    textTransform: "none",
    width: "100%",
    padding: "14px 32px",
    border: "1px dashed #FFFFFF33",
    borderRadius: "12px",
  },
  wideButton: { width: "100%" },
  monetizationSubtitle: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: 400,
    marginBottom: "24px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginTop: "4px",
      marginBottom: "32px",
    },
  },
  subscriptionChip: {
    width: "max-content",
    backgroundColor: "#FFFFFF0D",
    color: "#FFD0E1",
    borderRadius: 4,
    fontSize: 16,
    "&:focus": {
      backgroundColor: "#FFFFFF0D !important",
      outline: "none",
    },
  },
  subscriptionCounter: {
    display: "flex",
    alignItems: "baseline",
    gap: "8px",
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0px",
    },
  },
  subscriptionCounterLabel: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      fontWeight: 700,
    },
  },
  subscriptionCounterValue: {
    color: "#FFD0E1",
    fontSize: "24px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  subscriptionHint: {
    color: "#FFFFFFCC",
    fontSize: "14px",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: 1,
    },
  },
  createSubscriptionButton: {
    padding: "8px 16px",
    borderRadius: "6px",
    border: "1px solid #FE5A97",
    backgroundColor: "transparent",
    color: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "capitalize",
    "& .MuiButton-label": {
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      padding: "10px",
      minWidth: 0,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "40px 40px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "14px",
      paddingBottom: "8px",
    },
  },
  modalTitle: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  modalCloseButton: {
    padding: 4,
  },
  modalLabel: {
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: 700,
    marginTop: "16px",
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginTop: "4px",
    },
  },
  modalBody: {
    padding: "0 40px 40px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 14px 14px",
    },
  },
  priceRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "8px",
  },
  priceInput: {
    width: "122px",
    "& .MuiInputBase-input": {
      fontSize: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiInputBase-input": {
        fontSize: "14px",
      },
    },
  },
  chipGroup: {
    display: "flex",
    gap: "8px",
    backgroundColor: "#1F1F1F",
    borderRadius: "8px",
    padding: "2px",
  },
  chip: {
    padding: "2px 8px",
    borderRadius: "4px",
    border: "1px solid transparent",
    color: "#ffffff",
    backgroundColor: "transparent",
    textTransform: "none",
    fontSize: "12px",
    minWidth: "auto",
  },
  chipActive: {
    border: "1px solid #FE5A97",
    backgroundColor: "#FE5A97",
    color: "#ffffff",
    borderRadius: "4px",
  },
  addPeriodButton: {
    marginTop: "8px",
    padding: "7px 16px",
    minWidth: 0,
    textTransform: "none",
    color: "#FFFFFF",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: "#1F1F1F",
    borderRadius: "4px",
  },
  memberBenefitsList: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      gap: 5,
    },
  },
  memberBenefitsTitle: {
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: 700,
    marginBottom: "4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  memberBenefitsSubtitle: {
    color: "#FFFFFFCC",
    fontSize: "16px",
    fontWeight: 400,
    marginBottom: "12px",
    lineHeight: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  addBenefitsButton: {
    padding: "8px 16px",
    borderRadius: "6px",
    border: "1px solid #FE5A97",
    backgroundColor: "#FE5A97",
    color: "#ffffff",
    textTransform: "none",
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
  },
  removePeriodButton: {
    padding: 4,
    color: "#FFFFFFCC",
  },
  benefitsInputRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  addBenefitsIconButton: {
    minWidth: "auto",
    padding: "6px",
    borderRadius: "999px",
    backgroundColor: "#FF78AA",
    color: "#FFFFFF",
    width: "20px",
    height: "20px",
  },
  benefitInput: {
    flex: 1,
    border: "none",
    backgroundColor: "transparent",
    color: "#FFFFFF",
    fontSize: "14px",
    outline: "none",
  },
  benefitsList: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      gap: 4,
    },
  },
  benefitItem: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    borderRadius: "6px",
    gap: "6px",
  },
  benefitText: {
    color: "#FFFFFF",
    fontSize: "14px",
  },
  removeBenefitButton: {
    padding: 0,
    width: "20px",
    height: "20px",
    color: "#FF78AA",
    backgroundColor: "#1F1F1F",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tipsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    marginTop: 32,
    "& .MuiTextField-root": {
      width: "180px",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 12,
      "& .MuiTextField-root": {
        width: "168px",
      },
    },
  },
  modalTextField: {
    "& .MuiInputBase-root": {
      fontSize: "16px",
      fontWeight: 400,
      color: "#ffffff",
      backgroundColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #747474",
        borderRadius: "8px",
      },
      "&:hover fieldset": {
        borderColor: "#ffffff",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#FE5A97",
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        appearance: "none",
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },
    },
    "& .MuiInputAdornment-root": {
      color: "#ffffff",
      "& .MuiTypography-root": {
        color: "#ffffff",
      },
    },
  },
  priceInputHeight: {
    "& .MuiInputBase-root": {
      height: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiInputBase-root": {
        height: "30px",
      },
    },
  },
  modalInputHeight: {
    "& .MuiInputBase-root": {
      height: "44px",
    },
  },
  modalActions: {
    padding: "34px 40px 40px",
    display: "flex",
    gap: "32px",
    [theme.breakpoints.down("sm")]: {
      padding: "18px 14px 14px",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: "16px",
    },
  },
  modalButton: {
    flex: 1,
    borderRadius: "6px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "20px",
    height: "60px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
      height: "48px",
      width: "100%",
    },
  },
  modalButtonSecondary: {
    border: "1px solid #FE5A97",
    color: "#FFFFFF",
    backgroundColor: "transparent",
  },
  modalButtonPrimary: {
    backgroundColor: "#FE5A97",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0!important",
    },
  },
  deleteConfirmPaper: {
    backgroundColor: "#131313",
    color: "#fff",
    borderRadius: "12px",
    width: "777px",
    maxWidth: "100%",
    overflow: "hidden",
    margin: "24px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "calc(100vw - 32px)",
      margin: "16px",
    },
  },
  deleteConfirmHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    padding: "40px 40px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 16px 8px",
    },
  },
  deleteConfirmTitle: {
    color: "#ffffff",
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: 1.25,
    paddingRight: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  deleteConfirmSubtitle: {
    color: "#FFFFFFAA",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: 1.4,
    marginTop: "8px",
    maxWidth: "min(640px, 100%)",
  },
  deleteConfirmBody: {
    padding: "0 40px 40px",
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px 20px",
    },
  },
  deleteConfirmSummary: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) 1px minmax(0, 1fr)",
    alignItems: "center",
    columnGap: "20px",
    backgroundColor: "#1A1A1A",
    borderRadius: "8px",
    padding: "20px",
    boxSizing: "border-box",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      alignItems: "stretch",
      justifyContent: "space-around",
      gap: "16px",
    },
  },
  deleteConfirmSummaryLeft: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  deleteConfirmSummaryDivider: {
    width: "1px",
    height: "80px",
    justifySelf: "center",
    backgroundColor: "#2A2A2A",
  },
  deleteConfirmSummaryRight: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
  },
  deleteConfirmPlanName: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: 700,
  },
  deleteConfirmBenefitRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  deleteConfirmBenefitMark: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
  },
  deleteConfirmBenefitText: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: 1.35,
  },
  deleteConfirmPriceLine: {
    color: "#ffffff",
    fontSize: "18px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  deleteConfirmActions: {
    padding: "0 40px 40px",
    display: "flex",
    gap: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px 20px",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  subscriptionList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  subscriptionItem: {
    backgroundColor: "#131313",
    borderRadius: "8px",
    padding: "20px",
    display: "flex",
    flexDirection: "row",
    gap: "12px 4px",
    width: "100%",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
      alignItems: "flex-start",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px",
    },
  },
  subscriptionItemEditing: {
    border: "1px solid #D7A7B9",
    "& $subscriptionItemIconButton": {
      backgroundColor: "#D7A7B926",
    },
  },
  subscriptionItemInactive: {
    opacity: 0.5,
  },
  subscriptionItemName: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: 1,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  subscriptionItemMeta: {
    color: "#FFFFFFCC",
    fontSize: "14px",
    fontWeight: 400,
  },
  subscriptionItemBenefits: {
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  subscriptionItemOptions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  subscriptionItemPriceRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
  },
  subscriptionPriceValue: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  subscriptionPricePeriod: {
    fontSize: "20px",
    fontWeight: 400,
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  subscriptionItemTrialText: {
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 400,
    marginTop: "4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  subscriptionItemRight: {
    marginLeft: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    minWidth: "180px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "min-content",
    },
  },
  subscriptionPriceBadge: {
    color: "#ffffff",
    marginBottom: "4px",
  },
  subscriptionItemActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      position: "relative",
      gap: "24px",
    },
  },
  subscriptionItemIconButton: {
    padding: 0,
    width: "48px",
    height: "48px",
    color: "#FFFFFFCC",
    backgroundColor: "#1F1F1F80",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      width: "32px",
      height: "32px",
    },
  },
  subscriptionSwitch: {
    display: "flex",
    marginRight: "24px",
    // Перекриваємо стандартний MuiSwitch-sizeSmall
    "&.MuiSwitch-sizeSmall": {
      width: "44px",
      height: "24px",
      padding: 0,
    },
    // Перекриваємо продовський .MuiSwitch-sizeSmall .MuiSwitch-switchBase { padding: 4px; }
    "&.MuiSwitch-sizeSmall .MuiSwitch-switchBase": {
      padding: "0px !important",
    },
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transform: "translateX(0px)",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(20px) !important",
      color: "#ffffff !important",
      "& + .MuiSwitch-track": {
        backgroundColor: "#FE5A97 !important",
        opacity: 1,
      },
    },
    "& .MuiSwitch-thumb": {
      width: "20px !important",
      height: "20px !important",
      boxShadow: "none !important",
      backgroundColor: "#FFFFFF !important",
    },
    "& .MuiSwitch-track": {
      borderRadius: 12,
      backgroundColor: "#1F1F1F",
      opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: "0",
    },
  },
  subscriptionBenefitMark: {
    color: "#FF78AA",
    fontSize: "16px",
  },
  subscriptionItemRow: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      gap: "16px",
    },
  },
  /** Free plan edit: left + centered Week/Month between content and pencil */
  freePlanEditPlanRow: {
    width: "100%",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    gap: "12px",
  },
  freePlanEditChipsCenterWrap: {
    flex: "1 1 0%",
    minWidth: 0,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  subscriptionTrialPlanRight: {
    flexShrink: 0,
  },
  subscriptionItemLeft: {
    width: "247px",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    [theme.breakpoints.down("xs")]: {
      width: "153px",
    },
  },
  subscriptionItemTrialPlanLeft: {
    color: "#FFFFFF",
    fontSize: 20,
    fontWeight: 600,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  subscriptionTrialStatus: {
    color: "#FFFFFF",
    fontSize: 20,
    flex: 1,
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  /** Free tier inline edit: wider left column like screenshot */
  freePlanEditLeft: {
    minWidth: 0,
    maxWidth: "none",
  },
  /** Same typography as subscriptionItemName */
  freePlanEditTitleInput: {
    width: "100%",
    marginBottom: "16px",
    fontSize: "24px",
    fontWeight: 600,
    color: "#ffffff",
    lineHeight: 1.2,
    "&:before, &:after": {
      display: "none",
      borderBottom: "none",
    },
    "& .MuiInputBase-input": {
      padding: 0,
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
      color: "#ffffff",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  freePlanAddBenefitInput: {
    flex: 1,
    minWidth: 0,
    border: "none",
    backgroundColor: "transparent",
    color: "#FFFFFF",
    fontSize: "14px",
    outline: "none",
    "&::placeholder": {
      color: "#FFFFFFAA",
      opacity: 1,
    },
  },
  freePlanPeriodChip: {
    padding: "6px 12px",
    borderRadius: "8px",
    border: "1px solid transparent",
    color: "#ffffff",
    fontSize: "12px",
    fontWeight: 600,
    minWidth: "72px",
    textAlign: "center",
    display: "inline-block",
    boxSizing: "border-box",
    lineHeight: 1.2,
  },
  freePlanPeriodChipActive: {
    border: "1px solid #FE5A97",
    backgroundColor: "#FE5A97",
    color: "#ffffff",
  },
  freePlanPeriodChipInactive: {
    backgroundColor: "transparent",
    color: "#ffffff",
  },

  // Welcome dialog
  dialogRoot: {
    "& .MuiDialog-paper": {
      borderRadius: 12,
      backgroundColor: "#131313",
      padding: 40,
      color: "#FFFFFF",
    },
    "& .MuiDialogTitle-root": {
      padding: "0 0 32px 0",
    },
    "& .MuiDialogTitle-root h2": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& .MuiDialogContent-root": {
      padding: 0,
    },
  },
  uploadBox: {
    border: "2px dashed #FFFFFF33",
    textAlign: "center",
    cursor: "pointer",
    borderRadius: 16,
    padding: "99px 0",
    fontSize: 20,
  },
  smallUploadBox: {
    border: "2px dashed #FF78AA",
    height: 126,
    width: 108,
    borderRadius: 6,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
